import React from 'react';

import Helmet from 'common/helmets/Helmet';

const Title = 'Pricing | Canny';
const Description =
  'Canny costs less than building the wrong features. Canny pricing works for everyone - big or small, b2b or consumer. Get started for free!';
const Image = 'https://canny.io/images/canny-social.png';

export default function PricingV4Helmet() {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/pricing' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
}
